// import React, { useState, useEffect } from "react";

// const ServiceSectionAdmin = () => {
//   const [serviceData, setServiceData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });

//   useEffect(() => {
//     fetchServiceData();
//   }, []);

//   const fetchServiceData = async () => {
//     try {
//       const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section");
//       const result = await response.json();

//       if (!result.success) {
//         throw new Error(result.message || "Failed to fetch data");
//       }

//       setServiceData(result.data);
//     } catch (err) {
//       setMessage({ text: `Error: ${err.message}`, type: "danger" });
//       console.error("Error fetching features section data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setServiceData({
//       ...serviceData,
//       [name]: value,
//     });
//   };

//   const handleServiceChange = (index, field, value) => {
//     const updatedServices = [...serviceData.services];
//     updatedServices[index] = {
//       ...updatedServices[index],
//       [field]: value,
//     };
//     setServiceData({
//       ...serviceData,
//       services: updatedServices,
//     });
//   };

//   const addService = () => {
//     const newService = {
//       id: Date.now().toString(),
//       iconClass: "",
//       title: "",
//       description: "",
//       link: "",
//     };
//     setServiceData({
//       ...serviceData,
//       services: [...serviceData.services, newService],
//     });
//   };

//   const removeService = (index) => {
//     if (serviceData.services.length > 1) {
//       const updatedServices = [...serviceData.services];
//       updatedServices.splice(index, 1);
//       setServiceData({
//         ...serviceData,
//         services: updatedServices,
//       });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSaving(true);
//     setMessage({ text: "", type: "" });

//     try {
//       const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section", {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(serviceData),
//       });

//       const result = await response.json();

//       if (!result.success) {
//         throw new Error(result.message || "Failed to update data");
//       }

//       setServiceData(result.data);
//       setMessage({
//         text: "Feature section updated successfully!",
//         type: "success",
//       });
//     } catch (err) {
//       setMessage({ text: `Error: ${err.message}`, type: "danger" });
//       console.error("Error updating Feature section:", err);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleToggleActive = async () => {
//     try {
//       const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section/toggle", {
//         method: "PATCH",
//       });

//       const result = await response.json();

//       if (!result.success) {
//         throw new Error(result.message || "Failed to toggle status");
//       }

//       setServiceData(result.data);
//       setMessage({
//         text: `Feature section ${
//           result.data.isActive ? "activated" : "deactivated"
//         } successfully!`,
//         type: "success",
//       });
//     } catch (err) {
//       setMessage({ text: `Error: ${err.message}`, type: "danger" });
//       console.error("Error toggling Feature section status:", err);
//     }
//   };

//   const handleReset = async () => {
//     if (
//       !window.confirm(
//         "Are you sure you want to reset to default data? This cannot be undone."
//       )
//     ) {
//       return;
//     }

//     try {
//       const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section/reset", {
//         method: "POST",
//       });

//       const result = await response.json();

//       if (!result.success) {
//         throw new Error(result.message || "Failed to reset data");
//       }

//       setServiceData(result.data);
//       setMessage({
//         text: "Feature section reset to default successfully!",
//         type: "success",
//       });
//     } catch (err) {
//       setMessage({ text: `Error: ${err.message}`, type: "danger" });
//       console.error("Error resetting Feature section:", err);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="container mt-5">
//         <div className="text-center">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container mt-5">
//       <h2 className="mb-4">Manage Features Section</h2>

//       {message.text && (
//         <div className={`alert alert-${message.type}`} role="alert">
//           {message.text}
//         </div>
//       )}

//       <div className="card mb-4">
//         <div className="card-body">
//           <div className="d-flex justify-content-between align-items-center mb-3">
//             <h5 className="card-title">Section Status</h5>
//             <button
//               className={`btn ${
//                 serviceData?.isActive ? "btn-warning" : "btn-success"
//               }`}
//               onClick={handleToggleActive}
//             >
//               {serviceData?.isActive
//                 ? "Deactivate Section"
//                 : "Activate Section"}
//             </button>
//           </div>
//           <p className="card-text">
//             Current status:{" "}
//             <span
//               className={`badge bg-${
//                 serviceData?.isActive ? "success" : "danger"
//               }`}
//             >
//               {serviceData?.isActive ? "Active" : "Inactive"}
//             </span>
//           </p>
//           <button className="btn btn-outline-danger" onClick={handleReset}>
//             Reset to Default
//           </button>
//         </div>
//       </div>

//       <form onSubmit={handleSubmit}>
//         <div className="card mb-4">
//           <div className="card-header">
//             <h5 className="mb-0">Section Content</h5>
//           </div>
//           <div className="card-body">
//             <div className="mb-3">
//               <label htmlFor="sectionTitle" className="form-label">
//                 Section Title
//               </label>
//               <input
//                 type="text"
//                 className="form-control"
//                 id="sectionTitle"
//                 name="sectionTitle"
//                 value={serviceData?.sectionTitle || ""}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>

//             <div className="mb-3">
//               <label htmlFor="sectionDescription" className="form-label">
//                 Section Description
//               </label>
//               <textarea
//                 className="form-control"
//                 id="sectionDescription"
//                 name="sectionDescription"
//                 rows="3"
//                 value={serviceData?.sectionDescription || ""}
//                 onChange={handleInputChange}
//               ></textarea>
//             </div>
//           </div>
//         </div>

//         <div className="card mb-4">
//           <div className="card-header d-flex justify-content-between align-items-center">
//             <h5 className="mb-0">Features</h5>
//             <button
//               type="button"
//               className="btn btn-sm btn-primary"
//               onClick={addService}
//             >
//               Add Feature
//             </button>
//           </div>
//           <div className="card-body">
//             {serviceData?.services.map((service, index) => (
//               <div key={service.id} className="card mb-3">
//                 <div className="card-header d-flex justify-content-between align-items-center">
//                   <h6 className="mb-0">Feature #{index + 1}</h6>
//                   <button
//                     type="button"
//                     className="btn btn-sm btn-outline-danger"
//                     onClick={() => removeService(index)}
//                     disabled={serviceData.services.length <= 1}
//                   >
//                     Remove
//                   </button>
//                 </div>
//                 <div className="card-body">
//                   <div className="row">
//                     <div className="col-md-6 mb-3">
//                       <label className="form-label">Icon Class</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={service.iconClass}
//                         onChange={(e) =>
//                           handleServiceChange(
//                             index,
//                             "iconClass",
//                             e.target.value
//                           )
//                         }
//                         placeholder="e.g., ti-pencil-alt"
//                       />
//                     </div>
//                     <div className="col-md-6 mb-3">
//                       <label className="form-label">Title</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         value={service.title}
//                         onChange={(e) =>
//                           handleServiceChange(index, "title", e.target.value)
//                         }
//                         placeholder="Feature title"
//                       />
//                     </div>
//                   </div>
//                   <div className="mb-3">
//                     <label className="form-label">Description</label>
//                     <textarea
//                       className="form-control"
//                       rows="3"
//                       value={service.description}
//                       onChange={(e) =>
//                         handleServiceChange(
//                           index,
//                           "description",
//                           e.target.value
//                         )
//                       }
//                       placeholder="Feature description"
//                     ></textarea>
//                   </div>
               
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>

//         <div className="d-flex justify-content-between">
//           <button
//             type="button"
//             className="btn btn-secondary"
//             onClick={fetchServiceData}
//           >
//             Reset Changes
//           </button>
//           <button type="submit" className="btn btn-primary" disabled={saving}>
//             {saving ? (
//               <>
//                 <span
//                   className="spinner-border spinner-border-sm me-2"
//                   role="status"
//                   aria-hidden="true"
//                 ></span>
//                 Saving...
//               </>
//             ) : (
//               "Save Changes"
//             )}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default ServiceSectionAdmin;

import React, { useState, useEffect } from "react";

// Define a subset of Themify Icons for the picker
const themifyIcons = [
  'ti-home', 'ti-pencil-alt', 'ti-settings', 'ti-bell', 'ti-email', 
  'ti-calendar', 'ti-gallery', 'ti-tag', 'ti-pin-alt', 'ti-lock', 
  'ti-eye', 'ti-eye-off', 'ti-user', 'ti-support', 'ti-layout',
  'ti-layout-grid2', 'ti-layout-grid2-thumb', 'ti-layout-width-full', 
  'ti-layout-width-default', 'ti-layout-width-default-alt', 'ti-layout-tab',
  'ti-layout-tab-window', 'ti-layout-tab-v', 'ti-layout-tab-min', 
  'ti-layout-slider', 'ti-layout-slider-alt', 'ti-layout-sidebar-right',
  'ti-layout-sidebar-none', 'ti-layout-sidebar-left', 'ti-layout-placeholder',
  'ti-layout-menu', 'ti-layout-menu-v', 'ti-layout-menu-separated',
  'ti-layout-menu-full', 'ti-layout-media-right', 'ti-layout-media-right-alt',
  'ti-layout-media-overlay', 'ti-layout-media-overlay-alt', 'ti-layout-media-overlay-alt-2'
];

const ServiceSectionAdmin = () => {
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [currentServiceIndex, setCurrentServiceIndex] = useState(null);

  useEffect(() => {
    fetchServiceData();
  }, []);

  const fetchServiceData = async () => {
    try {
      const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section");
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.message || "Failed to fetch data");
      }
      setServiceData(result.data);
    } catch (err) {
      setMessage({ text: `Error: ${err.message}`, type: "danger" });
      console.error("Error fetching features section data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setServiceData({
      ...serviceData,
      [name]: value,
    });
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = [...serviceData.services];
    updatedServices[index] = {
      ...updatedServices[index],
      [field]: value,
    };
    setServiceData({
      ...serviceData,
      services: updatedServices,
    });
  };

  const addService = () => {
    const newService = {
      id: Date.now().toString(),
      iconClass: "",
      title: "",
      description: "",
      link: "",
    };
    setServiceData({
      ...serviceData,
      services: [...serviceData.services, newService],
    });
  };

  const removeService = (index) => {
    if (serviceData.services.length > 1) {
      const updatedServices = [...serviceData.services];
      updatedServices.splice(index, 1);
      setServiceData({
        ...serviceData,
        services: updatedServices,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage({ text: "", type: "" });
    try {
      const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(serviceData),
      });
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.message || "Failed to update data");
      }
      setServiceData(result.data);
      setMessage({
        text: "Feature section updated successfully!",
        type: "success",
      });
    } catch (err) {
      setMessage({ text: `Error: ${err.message}`, type: "danger" });
      console.error("Error updating Feature section:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleActive = async () => {
    try {
      const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section/toggle", {
        method: "PATCH",
      });
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.message || "Failed to toggle status");
      }
      setServiceData(result.data);
      setMessage({
        text: `Feature section ${
          result.data.isActive ? "activated" : "deactivated"
        } successfully!`,
        type: "success",
      });
    } catch (err) {
      setMessage({ text: `Error: ${err.message}`, type: "danger" });
      console.error("Error toggling Feature section status:", err);
    }
  };

  const handleReset = async () => {
    if (
      !window.confirm(
        "Are you sure you want to reset to default data? This cannot be undone."
      )
    ) {
      return;
    }
    try {
      const response = await fetch("https://ecommerce-product-05-19692c57dcd1.herokuapp.com/api/service-section/reset", {
        method: "POST",
      });
      const result = await response.json();
      if (!result.success) {
        throw new Error(result.message || "Failed to reset data");
      }
      setServiceData(result.data);
      setMessage({
        text: "Feature section reset to default successfully!",
        type: "success",
      });
    } catch (err) {
      setMessage({ text: `Error: ${err.message}`, type: "danger" });
      console.error("Error resetting Feature section:", err);
    }
  };

  const openIconPicker = (index) => {
    setCurrentServiceIndex(index);
    setShowIconPicker(true);
  };

  const selectIcon = (iconClass) => {
    if (currentServiceIndex !== null) {
      handleServiceChange(currentServiceIndex, "iconClass", iconClass);
    }
    setShowIconPicker(false);
  };

  if (loading) {
    return (
      <div className="container mt-5">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-5">
      <h2 className="mb-4">Manage Features Section</h2>
      {message.text && (
        <div className={`alert alert-${message.type}`} role="alert">
          {message.text}
        </div>
      )}
      <div className="card mb-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="card-title">Section Status</h5>
            <button
              className={`btn ${
                serviceData?.isActive ? "btn-warning" : "btn-success"
              }`}
              onClick={handleToggleActive}
            >
              {serviceData?.isActive
                ? "Deactivate Section"
                : "Activate Section"}
            </button>
          </div>
          <p className="card-text">
            Current status:{" "}
            <span
              className={`badge bg-${
                serviceData?.isActive ? "success" : "danger"
              }`}
            >
              {serviceData?.isActive ? "Active" : "Inactive"}
            </span>
          </p>
          <button className="btn btn-outline-danger" onClick={handleReset}>
            Reset to Default
          </button>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="card mb-4">
          <div className="card-header">
            <h5 className="mb-0">Section Content</h5>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="sectionTitle" className="form-label">
                Section Title
              </label>
              <input
                type="text"
                className="form-control"
                id="sectionTitle"
                name="sectionTitle"
                value={serviceData?.sectionTitle || ""}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="sectionDescription" className="form-label">
                Section Description
              </label>
              <textarea
                className="form-control"
                id="sectionDescription"
                name="sectionDescription"
                rows="3"
                value={serviceData?.sectionDescription || ""}
                onChange={handleInputChange}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="card mb-4">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Features</h5>
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={addService}
            >
              Add Feature
            </button>
          </div>
          <div className="card-body">
            {serviceData?.services.map((service, index) => (
              <div key={service.id} className="card mb-3">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">Feature #{index + 1}</h6>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeService(index)}
                    disabled={serviceData.services.length <= 1}
                  >
                    Remove
                  </button>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Icon</label>
                      <div className="d-flex align-items-center">
                        {service.iconClass && (
                          <i className={`${service.iconClass} me-2`} style={{ fontSize: '1.5rem' }}></i>
                        )}
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => openIconPicker(index)}
                        >
                          {service.iconClass ? 'Change Icon' : 'Select Icon'}
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control"
                        value={service.title}
                        onChange={(e) =>
                          handleServiceChange(index, "title", e.target.value)
                        }
                        placeholder="Feature title"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={service.description}
                      onChange={(e) =>
                        handleServiceChange(
                          index,
                          "description",
                          e.target.value
                        )
                      }
                      placeholder="Feature description"
                    ></textarea>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={fetchServiceData}
          >
            Reset Changes
          </button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </form>

      {/* Icon Picker Modal */}
      {showIconPicker && (
        <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Select an Icon</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowIconPicker(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="row">
                  {themifyIcons.map((icon, index) => (
                    <div key={index} className="col-3 col-md-2 mb-3 text-center">
                      <button
                        type="button"
                        className="btn btn-light w-100 d-flex flex-column align-items-center justify-content-center p-2"
                        onClick={() => selectIcon(icon)}
                      >
                        <i className={`${icon} mb-1`} style={{ fontSize: '1.5rem' }}></i>
                        <small>{icon.replace('ti-', '')}</small>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceSectionAdmin;